import React, { Component } from 'react'
import { difference, find, includes, range, size } from 'lodash'
import CasePickerItem from './CasePickerItem'
import { CaseData } from '../apis/inventoryCase.api'
import Card from './Card'
import List, { ListItem } from './List'

interface CasePickerProps {
  cases: number
  availables: number[]
  selectedPositions: number[]
  selectedCases: (CaseData | null)[]
  onSelect?: (position: number) => void
}

interface State {
  selectedCase: CaseData | null
}

export default class CasePicker
  extends Component<CasePickerProps, State> {
  constructor (props: CasePickerProps) {
    super(props)
    this.state = {
      selectedCase: null
    }
  }

  status (position: number) {
    const availables = this.props.availables || range(1, this.props.cases + 1)
    const isSelected = includes(this.props.selectedPositions, position)
    const isAvailable = includes(availables, position)
    return isSelected
      ? 'selected'
      : isAvailable
        ? 'available'
        : 'unavailable'
  }

  get unavailables () {
    const cases = range(1, this.props.cases + 1)
    return difference(cases, this.props.availables)
  }

  get availables () {
    return difference(this.props.availables, this.props.selectedPositions)
  }

  case (position: number) {
    return (
      <div
        key={position}
        className="float-left p-1">
        <CasePickerItem
          size="medium"
          status={this.status(position)} />
      </div>
    )
  }

  get selectedCases () {
    return this.props.selectedPositions.map(position => {
      return (
        <div
          key={position}
          onClick={() => this.handleSelectedCaseClick(position)}
          className="cursor-pointer">
          {this.case(position)}
        </div>
      )
    })
  }

  get availableCases () {
    return this.availables.map(position => {
      return this.case(position)
    })
  }

  get unavailableCases () {
    return this.unavailables.map(position => {
      return this.case(position)
    })
  }

  get availableSpace () {
    const availableSpace = size(this.availables)
    return Boolean(this.props.cases) &&
      <small className='text-xs mb-5'>
        Available cases on pallet: {availableSpace}
      </small>
  }

  get selectedCaseDetails () {
    if (!this.state.selectedCase) return null
    const { code, number, quantity } = this.state.selectedCase
    const listItems: ListItem[] | null = [
      { key: 'Case', value: code },
      { key: 'Case number', value: number },
      { key: 'Quantity', value: quantity }
    ]
    return listItems && (
      <Card className='mb-4'>
        <List items={listItems} />
      </Card>
    )
  }

  handleSelectedCaseClick = (position: number) => {
    const selectedCase = find(this.props.selectedCases, (_, index) => {
      return index === position
    })
    this.setState(state => {
      if (!selectedCase) {
        return { selectedCase: null }
      } else if (state.selectedCase && state.selectedCase.id === selectedCase.id) {
        return { selectedCase: null }
      } else {
        return { selectedCase: selectedCase }
      }
    })
  }

  render () {
    return (
      <>
        {this.selectedCaseDetails}
        <div className='flex flex-col'>
          <div className="inline-block mb-2">
            {this.selectedCases}
            {this.availableCases}
            {this.unavailableCases}
          </div>
          {this.availableSpace}
        </div>
      </>
    )
  }
}
